import { useSession } from "hooks/useSession";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
import TransferRAmountModal from "./components/TransferRAmountModal";

function MainRWalletSettlement() {
    const [modalShow, setModalShow] = useState(false);
    const [modalMode, setModalMode] = useState("add");
    const [selectedUser, setSelectedUser] = useState(null);
  const {name, userid, role} = useSession();
  const [data, setData] = useState(null); // to store API data
  const [loading, setLoading] = useState(true); // to manage loader
  const [error, setError] = useState(null); // to handle errors
  const navigate = useNavigate()
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetchWrapper(
        `https://pro.mokshiq.in/get_user_profile?user=24`
      );
     
     
      setData(response.data);
    } catch (err) {
  //    showMainToast(err.message, 'danger');
    } finally {
      setLoading(false); // hide loader
    }
  };
  useEffect(() => {
    

    fetchData();
  }, []);

  
  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };

  const createContact = async () =>{
    try{
    setLoading(true);
        const formData = new FormData();
        // formData.append("userid", "3");
        const response = await fetchWrapper(
          `https://pro.mokshiq.in/create_contect?userid=24`
        );
        
        const result =  response;
      
        if (result.status) {
          showMainToast(result.message, "success");
          fetchData();
        }
        
        else{
            setError(result.message); 
        }
        // setData(result.data);
      } catch (err) {
        showMainToast(err.message, "danger");
      } finally {
        setLoading(false); // hide loader
      }
    
  }
  const createFundAccount = async () =>{
    try{
    setLoading(true);
        const formData = new FormData();
        // formData.append("userid", "3");
        const response = await fetchWrapper(
          `https://pro.mokshiq.in/create_fund_account?userid=24`
        );
       
        const result =  response;
      
        if (result.status) {
          showMainToast(result.message, "success");
          fetchData();
        }
        
        else{
            setError(result.message); 
        }
        // setData(result.data);
      } catch (err) {
        showMainToast(err.message, "danger");
      } finally {
        setLoading(false); // hide loader
      }
    
  }

  return (
    <main>
      <div className="container-fluid ui-section">
        <div className="row m-1">
          <div className="col-12 ">
            <h4 className="main-title">Main Wallet Settlement</h4>
            <ul className="app-line-breadcrumbs mb-3">
              <li>
                <a className="f-s-14 f-w-500" href="#">
                  <span>
                    <i className="ph-duotone ph-briefcase-metal f-s-16"></i>{" "}
                    Services
                  </span>
                </a>
              </li>
              <li className="active">
                <a className="f-s-14 f-w-500" href="#">
                  Main Wallet Settlement
                </a>
              </li>
            </ul>
          </div>
        </div>

        {loading ? (
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="loader-container">
                    <div className="loader-main">
                      <div className="loader_box">
                        <div className="loader_16"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
            <div className="row">
            {data && (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Quick Payout</h5>
                    <p className="mb-0 text-secondary">
                      {data.contact_id === "" && data.fund_id === ""
                        ? "Submit KYC – Aadhaar, PAN, and Bank details."
                        : data.contact_id !== "" && data.fund_id === ""
                        ? "Please initiate onboarding with bank."
                        : "Transfer amount in your account. ✅"}
                    </p>
                  </div>
                  <div className="card-body">
                    {data.contact_id === "" && data.fund_id === "" && (
                      <button
                        className="btn btn-light-primary btn-md"
                        type="button"
                        onClick={createContact}
                      >
                        Create Contact
                      </button>
                    )}
          
                    {data.contact_id !== "" && data.fund_id === "" && (
                      <button className="btn btn-warning btn-md" type="button" onClick={createFundAccount}>
                        Create Fund Account
                      </button>
                    )}
          
                    {data.contact_id !== "" && data.fund_id !== "" && (
                      <button
                        className="btn btn-primary btn-md"
                        type="button"
                        onClick={handleAddUser}
                      >
                        Start Transaction
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          
        )}
      </div>
      <TransferRAmountModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
      />
    </main>
  );
}

export default MainRWalletSettlement;
